import React, { useContext, useEffect } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Modal,
  IconButton,
  Grid,
  Button,
  Box,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import CloseIconIMG from '../../images/Icon.svg';
import { SessionTimeoutModalStyles as classes } from './SessionTimeoutModalStyles';
import {
  CONTINUE,
  CLOSE,
  INACTIVEMODAL_TEXT_ONE,
  INACTIVE_MODAL_MSG,
  SESSION_INACTIVITY_MSG,
} from '../../constants';
import { commonTernary, isBundle } from '../commonCode';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import { CloseIcon, InactivityIcon } from '../../images/svg/CustomizedSVG';

function InactivityModal({ setOpenInactivityModal, resetTimer, openModal }) {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const leadGenerationContext = useContext(LeadGenerationContext);

  const themes = useTheme();
  const isMobile = useMediaQuery(themes?.breakpoints?.down('600'), {
    defaultMatches: true,
  });

  const handleContinue = () => {
    setOpenInactivityModal(false);
    resetTimer();
  };

  const handleClose = () => {
    setOpenInactivityModal(false);
  };

  useEffect(() => {
    if (openModal) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [openModal]);

  const textLineOne = INACTIVE_MODAL_MSG;

  const bundleModal = () => (
    <Modal
      disableScrollLock
      sx={classes.backdrop}
      slotProps={{
        backdrop: {
          sx: { backgroundColor: 'rgba(233, 233, 235, 0.78)' },
        },
      }}
      open={open}
      role="dialog"
      aria-describedby="dialog1Desc dialog2Desc"
    >
      <Box
        component="div"
        sx={{ ...classes.productmodal, background: leadGenerationContext?.theme?.customBackground }}
      >
        {!isMobile && (
          <Grid container sx={classes.productmodalcontainer}>
            <IconButton
              src={CloseIconIMG}
              name="closeicon"
              onClick={handleClose}
              tabIndex="0"
              data-testid="close_id"
              id="businessAddressEdit"
              disableRipple
            >
              <CloseIcon
                height="30px"
                width="30px"
                color={leadGenerationContext?.theme?.palette?.orientalPrimary?.main}
              />
            </IconButton>
          </Grid>
        )}
        <InactivityIcon
          height="63px"
          width="54px"
          color={leadGenerationContext?.theme?.palette?.modalIconColor?.main}
        />

        <Typography
          sx={{
            ...classes.inactivityMSG,
            color: leadGenerationContext?.theme?.palette?.primary?.main,
          }}
          id="dialog1Desc"
        >
          {t(SESSION_INACTIVITY_MSG, { defaultValue: SESSION_INACTIVITY_MSG })}
        </Typography>

        <Grid container sx={classes.buttonContainer}>
          <Button
            disableFocusRipple
            autoFocus
            sx={{
              ...classes.restartButton,
              background: 'transparent !important',
              color: leadGenerationContext?.theme?.palette?.orientalPrimary?.main,
              border: `1.6px solid ${leadGenerationContext?.theme?.palette?.orientalPrimary?.main}`,
              flex: 1,
              '&:hover': {
                backgroundColor: 'transparent !important',
              },
            }}
            onClick={handleClose}
          >
            {t(CLOSE, { defaultValue: CLOSE })}
          </Button>
          <Button
            disableFocusRipple
            autoFocus
            sx={{
              ...classes.restartButton,
              background: leadGenerationContext?.theme?.palette?.orientalPrimary?.main,
              color: leadGenerationContext?.theme?.palette?.secondary?.main,
              border: `1.6px solid transparent`,
              flex: 1,
              '&:hover': {
                backgroundColor: leadGenerationContext?.theme?.palette?.orientalPrimary?.main,
              },
            }}
            onClick={handleContinue}
          >
            {t(CONTINUE, { defaultValue: CONTINUE })}
          </Button>
        </Grid>
      </Box>
    </Modal>
  );

  const oldInactivityModal = () => (
    <Modal
      disableScrollLock
      sx={classes.backdrop}
      slotProps={{
        backdrop: {
          sx: { backgroundColor: 'rgba(233, 233, 235, 0.78)' },
        },
      }}
      open={open}
      role="dialog"
      aria-describedby="dialog1Desc"
    >
      <Box sx={classes.sessionmodal}>
        <Grid container sx={classes.sessioncontainer}>
          <IconButton
            onClick={handleClose}
            src={CloseIconIMG}
            name="closeicon"
            data-testid="inactivityModal_id"
            id="inactivityModal_id"
            disableRipple
            sx={classes.closeOverlay}
          >
            <img
              alt={t(`close`, { defaultValue: 'close' })}
              src={CloseIconIMG}
              width="20px"
              height="20px"
            />
          </IconButton>
        </Grid>
        <Grid container>
          <Card sx={classes.inactivityModalRoot}>
            <CardContent sx={classes.card_content}>
              <Typography sx={classes.textOneInactiveStyle} id="dialog1Desc">
                {t(INACTIVEMODAL_TEXT_ONE, { defaultValue: textLineOne })}
              </Typography>
              <Button
                disableFocusRipple
                autoFocus
                sx={classes.continueAppButton}
                onClick={handleContinue}
              >
                {t(CONTINUE, { defaultValue: CONTINUE })}
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Box>
    </Modal>
  );

  return commonTernary(
    isBundle(leadGenerationContext.productName) ||
      leadGenerationContext.flowTypeVerifyScreen === 'bundleLoginScreen',
    bundleModal(),
    oldInactivityModal()
  );
}

export default withRouter(InactivityModal);

InactivityModal.propTypes = {
  setOpenInactivityModal: PropTypes.func,
  resetTimer: PropTypes.func,
  openModal: PropTypes.bool,
};
